import { featureFlagsStore } from 'store';

export const useFeatureFlags = () => {
  const {
    isLoading,
    isFetching,
    data: featureFlags,
  } = featureFlagsStore.service.useGetFeatureFlagsQuery();

  return {
    isComputerMediatedSpeakingEnabled: featureFlags?.isComputerMediatedSpeakingEnabled ?? false,
    isLoading,
    isFetching,
  };
};
